module.exports = __webpack_public_path__ + "img/1264w.8117d11.jpg";